var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.903,
    height: 84.353,
    viewBox: "0 0 50.903 84.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(-154 -343)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 40.636,
    height: 75.627,
    transform: "translate(159.158 343)",
    fill: "#2bbf4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 50.903,
    height: 8.726,
    transform: "translate(154 418.627)",
    fill: "#208f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M50.362,39.5a1.906,1.906,0,0,0-1.76-1.177H44.074l5.017-5.017A1.9,1.9,0,1,0,46.4,30.613l-8.263,8.27a1.9,1.9,0,0,0,1.347,3.252h4.528L38.484,47.65a1.9,1.9,0,1,0,2.694,2.694l8.771-8.77a1.905,1.905,0,0,0,.413-2.074Z",
    transform: "translate(135.649 354.169)",
    fill: "#faea1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 24.724,
    height: 27.633,
    rx: 4,
    transform: "translate(193.113 350.224) rotate(90)",
    fill: "#eef4fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(171.602 355.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 2.515,
    cy: 2.515,
    r: 2.515,
    transform: "translate(0)",
    fill: "#2bbf4a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 2.515,
    cy: 2.515,
    r: 2.515,
    transform: "translate(10.445)",
    fill: "#2bbf4a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M-1995,1865.791s6.75-6.385,15.61,0",
    transform: "translate(1995.383 -1852.487)",
    fill: "none",
    stroke: "#2bbf4a",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.03752a20d7ae7bbcebd7acb25149c7ca.svg";
export { ForwardRef as ReactComponent };